import React from 'react';

const ppc = () => {
return (
<>
  <section
    className="seo-ban  text-center"
    style={{ backgroundImage: "url(assets/img/abm-bg.png)" }}
  >
    <i className="glow-2" />
    <div className="container-lg inner-container position-relative">
      <div className="row justify-content-center">
        <div className="col-xl-9">
          <h1 className="seo-ts-head">
            Drive Sales with Pay Per Click (PPC) Advertising Management Services
          </h1>
          <h2 className="seo-ts-head-2">Let’s get high. ROI!</h2>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-9">
          <p className="mb-lg-4">
            Elevate your marketing strategy to new heights with our Pay Per
            Click (PPC) advertising management services. Our expertise turns
            digital interactions into tangible results, ensuring each click is a
            step towards achieving your business objectives and maximizing your
            return on investment (ROI).
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    className="some-amazing-brands"
    style={{ backgroundImage: "url(assets/img/some-amazing-brands.png)" }}
  >
    <div className="container-lg inner-container position-relative">
      <h4 className="fs-32 text-white ui-mb-res-30">
        Some of the Amazing Brands We've Worked With
      </h4>
      <div className="row">
        <div className="col-xl-10">
          <p className="fs-20 text-white">
            Our collaboration with industry-leading brands showcases our ability
            to drive success and build trust through effective PPC campaigns.
          </p>
        </div>
      </div>
    </div>
    <div className="owl-pl">
      <div className="owl-carousel owl-brands">
        <div className="item">
          <div className="item-brand">
            <a href="accellor.html" className="res-a" />
            <img src="assets/img/clients-1/accellor.png" alt="" />
          </div>
        </div>
        <div className="item">
          <div className="item-brand">
            <a href="#" className="res-a" />
            <img src="assets/img/clients-1/brand-allyo.png" alt="" />
          </div>
        </div>
        <div className="item">
          <div className="item-brand">
            <a href="#" className="res-a" />
            <img
              src="assets/img/clients-1/brand-aligned-automation.png"
              alt=""
            />
          </div>
        </div>
        <div className="item">
          <div className="item-brand">
            <a href="#" className="res-a" />
            <img src="assets/img/clients-1/asparia.png" alt="" />
          </div>
        </div>
        <div className="item">
          <div className="item-brand">
            <a href="#" className="res-a" />
            <img src="assets/img/clients-1/blastwave.png" alt="" />
          </div>
        </div>
        <div className="item">
          <div className="item-brand">
            <a href="#" className="res-a" />
            <img src="assets/img/clients-1/accellor.png" alt="" />
          </div>
        </div>
        <div className="item">
          <div className="item-brand">
            <a href="#" className="res-a" />
            <img
              src="assets/img/clients-1/brand-aligned-automation.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="bg-010101 ui-pt-res-100 ui-pb-res-60">
    <div className="container-lg inner-container position-relative text-white">
      <h3 className="ts-parallel text-white ui-mb-res-30">
        Our ROI-Driven Pay-Per-Click (PPC) Advertising Process
      </h3>
      <div className="row">
        <div className="col-xl-11">
          <p className="wee-off">
            At Purplepatch Services, we tailor our PPC advertising process to
            meet the unique needs of your business. By understanding your goals,
            audience, and value proposition, we develop a customized campaign
            strategy designed to attract your target customers, increase leads
            and traffic, and boost your ROI through:
          </p>
        </div>
      </div>
      <div className="row rw-divide-1 rw-divide-v1">
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 strategic-planning"></div>
            <h5>Strategic Planning</h5>
            <p>
              We dive deep into your business, industry, and audience to uncover
              opportunities and craft a PPC strategy that aligns with your
              objectives.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 customized-campaign"></div>
            <h5>Customized Campaign Setup</h5>
            <p>
              From keyword selection and ad creation to targeting and bidding
              strategies, our experts ensure your campaign is set for success.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 identify-icon"></div>
            <h5>Ongoing Monitoring and Management</h5>
            <p>
              We continuously track and refine your campaign based on
              performance metrics, ensuring optimal results.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2  analyze-icon"></div>
            <h5>Conversion Tracking and Analysis</h5>
            <p>
              Focusing on meaningful actions, we provide insights into user
              behavior and campaign effectiveness.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 ad-testing"></div>
            <h5>Ad Testing and Refinement</h5>
            <p>
              Regular experimentation with ad elements helps us discover what
              truly engages your audience.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 performance-reporting"></div>
            <h5>Performance Reporting</h5>
            <p>
              Our transparent reporting keeps you informed on your campaign's
              impact, guiding future strategy adjustments.
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-11">
          <h3 className="ts-parallel ui-mb-res-30 ui-pt-res-30 text-white">
            Our Comprehensive Pay-Per-Click (PPC) Advertising Services
          </h3>
          <p className="wee-off">
            We offer a wide range of PPC advertising services designed to
            enhance your online presence and drive measurable outcomes,
            including:
          </p>
        </div>
      </div>
      <div className="row rw-divide-1">
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 google-Ads-icon"></div>
            <h5>Google Ads Management</h5>
            <p>
              Maximize visibility and attract leads with tailored Google Ads
              campaigns across various ad formats.
            </p>
            <ul className="bx-1-ul">
              <li>Demand Gen Ads</li>
              <li>Search Ads</li>
              <li>Display Ads</li>
              <li>Discovery Ads</li>
              <li>Performance Max Ads</li>
              <li>Shopping Ads</li>
              <li>Video Ads</li>
              <li>App Ads</li>
            </ul>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 social-media-Ads-icon"></div>
            <h5>Social Media Ads Management</h5>
            <p>
              Connect with your audience on their favorite platforms with
              engaging, personalized social media ads.
            </p>
            <ul className="bx-1-ul">
              <li>Facebook Ads</li>
              <li>Instagram Ads</li>
              <li>LinkedIn Ads</li>
              <li>Twitter Ads</li>
              <li>YouTube Ads</li>
              <li>Pinterest Ads</li>
            </ul>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 content-strategy-development-icon"></div>
            <h5>Remarketing and Retargeting Ads Management</h5>
            <p>
              Re-engage visitors with customized ads that remind them of what
              they're missing.
            </p>
            <ul className="bx-1-ul">
              <li>Audience Segmentation</li>
              <li>Ad Creation and Optimization</li>
              <li>Campaign Management and Optimization</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="inside-chooser">
    <div className="container-lg inner-container position-relative">
      <div className="row">
        <div className="col-lg-6 pe-xl-5">
          <h3 className="tp-ms-head pe-xl-4">
            Why Choose Us for{" "}
            <span className="c-primary1">Pay-Per-Click (PPC)</span> Advertising
            Services
          </h3>
        </div>
        <div className="col-lg-6 px-xl-5">
          <ul className="list-style-1 list-style-1-cnt">
            <li>
              <span className="hhtop">Focused Expertise:</span>
              <p>
                Our experienced team provides insights and regular updates,
                freeing you to focus on your business.
              </p>
            </li>
            <li>
              <span className="hhtop">Accelerated ROI:</span>
              <p>
                Innovative campaigns crafted by our marketing specialists drive
                revenue faster.
              </p>
            </li>
            <li>
              <span className="hhtop">Enhanced Profit Margins:</span>
              <p>
                We're committed to growing your revenue with high-quality PPC
                services.
              </p>
            </li>
            <li>
              <span className="hhtop">Maximized Reach:</span>
              <p>
                Our cross-platform strategies ensure your campaigns have the
                broadest impact.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section className="seo-accordion accordion-style">
    <div className="container-lg inner-container position-relative text-white">
      <div className="row">
        <div className="col-xl-9">
          <h3 className="ts-parallel text-black ui-mb-res-60">
            FAQs about Pay-Per-Click (PPC) Advertising Management Services
          </h3>
        </div>
      </div>
      <div className="accordion" id="ac1">
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              What is pay-per-click (PPC)?
            </button>
          </h5>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                PPC is an online advertising model where advertisers pay each
                time a user clicks on one of their ads, offering a direct route
                to increasing website traffic and conversions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section
    className="footer-above-services text-white"
    style={{ backgroundImage: "url(assets/img/footer-above-services.png)" }}
  >
    <div className="container-lg inner-container">
      <div className="row">
        <div className="col-xl-9 pe-lg-4">
          <h3 className="tp-set">
            Elevate Your Online Presence with Expert{" "}
            <span className="c-FDB3D4">
              PPC Advertising Management Services
            </span>{" "}
          </h3>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-7 pe-lg-4">
          <p>
            Partner with <b>Purplepatch Services</b> for expert guidance and
            tailored strategies that drive results. Our commitment to your
            success ensures your PPC campaigns not only reach but exceed your
            marketing goals. Contact us to discover how we can boost your
            digital marketing success today.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    className="get-form-touch"
    style={{ backgroundImage: "url(assets/img/get-form-touch.png)" }}
  >
    <div className="container-lg inner-container">
      <div className="row">
        <div className="col-md-6 text-white">
          <h5 className="ss-1">Contact</h5>
          <h4 className="ss-2">
            Ready to start your growth with Our B2B Digital Marketing Service?
          </h4>
          <div className="home-feat-article">
            <div className="dflex-1 text-black">
              <div className="dflex-1-cnt">
                <h6>Featured Article</h6>
                <h5>What is good conversion rate?</h5>
              </div>
              <div className="dflex-1-icon">
                <img src="assets/img/peop-1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 text-white">
          <h6 className="ss-3">
            Your success story begins here. Connect with us today!
          </h6>
          <p>
            Are you ready to start elevating your brand and getting results?
            Then stop reading and start typing! Fill out the form and let’s
            begin…
          </p>
        </div>
      </div>
    </div>
  </section>
</>


  );
};

export default ppc;